import { render } from "./makeBookingFromVoucherModal.vue?vue&type=template&id=5b5fdc28&ts=true"
import script from "./makeBookingFromVoucherModal.vue?vue&type=script&lang=ts"
export * from "./makeBookingFromVoucherModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__